module.exports = __webpack_public_path__ + "static/media/05-usa.fcc5e18b.png";